import React from 'react';
import ScrollFloat from './ScrollFloat';
import './Pricing.css';

const Pricing = ({
  title = "Cenník",
  subtitle = "Automatizovaný AI dispečing pre moderné taxislužby",
  pricingPlans = [
    {
      name: "AI Dispečing",
      price: "Dohoda po",
      period: "konzultácii",
      description: "Kompletné riešenie pre automatizovaný dispečing vašej taxislužby",
      features: [
        "Automatické rozpoznávanie hlasu zákazníkov",
        "Inteligentné prideľovanie objednávok taxikárom",
        "Real-time dashboard s prehľadom všetkých jazd",
        "SMS a push notifikácie pre vodičov",
        "Vlastné nastavenie hlasových odpovedí",
        "Integrácia s existujúcimi systémami",
        "Detailné reporty a analytiky",
        "24/7 technická podpora a údržba",
        "Pravidelné aktualizácie AI modelu",
        "Flexibilné platobné podmienky"
      ],
      popular: true,
      buttonText: "Dohodnúť konzultáciu",
      color: "dark"
    }
  ]
}) => {
  
  const handlePlanSelect = (plan) => {
    console.log(`Selected plan: ${plan.name}`);
    // TODO: Implement consultation booking logic
  };

  return (
    <section className="pricing" id="cennik">
      <div className="container">
        <div className="pricing-header-section">
          <ScrollFloat 
            animationDuration={0.8}
            ease='power2.out'
            scrollStart='top bottom-=100px'
            scrollEnd='center center'
            stagger={0.05}
            containerClassName="pricing-title-scroll"
            textClassName="pricing-title-text"
          >
            {title}
          </ScrollFloat>
          
          <ScrollFloat 
            animationDuration={0.6}
            ease='power1.out'
            scrollStart='top bottom-=80px'
            scrollEnd='center center+=50px'
            stagger={0.03}
            containerClassName="pricing-subtitle-scroll"
            textClassName="pricing-subtitle-text"
          >
            {subtitle}
          </ScrollFloat>
        </div>
        
        <div className="pricing-grid single-plan scroll-reveal">
          {pricingPlans.map((plan, index) => (
            <div 
              key={index} 
              className={`pricing-card ${plan.popular ? 'popular' : ''} ${plan.color}`}
            >
              {plan.popular && (
                <div className="popular-badge">
                  Kompletné riešenie
                </div>
              )}
              
              <div className="pricing-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="custom-price">{plan.price}</span>
                  <span className="custom-period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              
              <div className="pricing-features">
                <ul>
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="pricing-footer">
                <button 
                  className={`pricing-button ${plan.popular ? 'primary' : 'secondary'}`}
                  onClick={() => handlePlanSelect(plan)}
                >
                  {plan.buttonText}
                </button>
                <p className="pricing-note-small">
                  Po registrácii si vytvoríte vlastný profil a nastavíte si konfiguráciu vašej taxislužby.
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="pricing-note">
          <p>
            <strong>Každé riešenie je jedinečné.</strong> Kontaktujte nás pre bezplatnú konzultáciu 
            a cenový návrh prispôsobený vašej taxíkovej firme. Možnosť testovacieho obdobia.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing; 